import '@loyal_molecules/footer.css'
import PropTypes from 'prop-types'
import React, { Fragment, Component } from 'react'
import ReactPlaceholder from 'react-placeholder'
import 'react-placeholder/lib/reactPlaceholder.css'
import FooterPlaceholder from './FooterPlaceholder'
import yn from 'yn'

import { features, ToggleFeature } from 'features/ToggleFeature'

class Footer extends Component {
  render () {
    return (
      <Fragment>
        {!yn(process.env.REACT_APP_ISMAINTENANCE) ? (
          <ReactPlaceholder ready customPlaceholder={<FooterPlaceholder />}>
            <footer id='footer' title='rodapé' className='box-footer d-print-none'>
              <ToggleFeature feature={features.footerContent} profile={this.props.profile} footerMenu={this.props.footerMenu} meuBairro={this.props.meuBairro} />
            </footer>
          </ReactPlaceholder>
        ) : ('')}
      </Fragment>
    )
  }
}

Footer.propTypes = {
  profile: PropTypes.object,
  footerMenu: PropTypes.object,
  meuBairro: PropTypes.bool
}

export default Footer



// WEBPACK FOOTER //
// ./src/App/Footer/Footer.js